import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  languages,
  usePublicLanguage,
  usePublicTranslation,
} from "@/features/utils/i18n";

export function LanguageSelector() {
  const { currentLanguage, changeLanguage } = usePublicLanguage();
  const { t } = usePublicTranslation();

  return (
    <div className="space-y-2">
      <Label htmlFor="language" className="flex items-center gap-2">
        {t("language_selector.label")}
      </Label>
      <Select
        value={currentLanguage}
        onValueChange={(value) => changeLanguage(value)}
      >
        <SelectTrigger id="language">
          <SelectValue placeholder={t("language_selector.placeholder")} />
        </SelectTrigger>
        <SelectContent>
          {Object.entries(languages).map(([code, label]) => (
            <SelectItem key={code} value={code}>
              {label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
